import querystring from 'querystring';
import { pickBy } from 'lodash';

import splitUrl from './splitUrl';

import { Params } from './types';

const filterEmptyKeys = (obj: Params) => pickBy(obj, (_, key) => !!key);

/**
 * Extracts query params from a URL and returns them as an object.
 *
 * Filters out empty params so the returned object has defined values.
 */
const extractParams = (url = '') => {
  const params = querystring.parse(splitUrl(url).queryString);
  // Handles a params object that was extracted from an URL with a trailing `&`,
  // which would result in an empty key/value pair.
  return filterEmptyKeys(params);
};

export default extractParams;
